import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE } from "../constants/common";
import enCommonLocationAddress from "../locales/en/CommonLocationAddress.json";
import enFleetManagerInfo from "../locales/en/FleetManagerInfo.json";
import enFleetVehicles from "../locales/en/FleetVehicles.json";
import enStepIntro from "../locales/en/StepIntro.json";
import enAccountCar from "../locales/en/accountCar.json";
import enAddVehicle from "../locales/en/addVehicle.json";
import enCommon from "../locales/en/common.json";
import enCompleteVehicleDetails from "../locales/en/completeVehicleDetails.json";
import enDriverOnboarding from "../locales/en/driverOnboarding.json";
import enErrorBoundary from "../locales/en/errorBoundary.json";
import enFleetCongratulations from "../locales/en/fleetCongratulations.json";
import enHome from "../locales/en/home.json";
import enHowToGetVin from "../locales/en/howToGetVin.json";
import enNotifyDrivers from "../locales/en/notifyDrivers.json";
import enUnknownVinDialog from "../locales/en/unknownVinDialog.json";
import enYup from "../locales/en/yup.json";
import frCommonLocationAddress from "../locales/fr/CommonLocationAddress.json";
import frFleetManagerInfo from "../locales/fr/FleetManagerInfo.json";
import frFleetVehicles from "../locales/fr/FleetVehicles.json";
import frStepIntro from "../locales/fr/StepIntro.json";
import frAccountCar from "../locales/fr/accountCar.json";
import frAddVehicle from "../locales/fr/addVehicle.json";
import frCommon from "../locales/fr/common.json";
import frCompleteVehicleDetails from "../locales/fr/completeVehicleDetails.json";
import frDriverOnboarding from "../locales/fr/driverOnboarding.json";
import frErrorBoundary from "../locales/fr/errorBoundary.json";
import frFleetCongratulations from "../locales/fr/fleetCongratulations.json";
import frHome from "../locales/fr/home.json";
import frHowToGetVin from "../locales/fr/howToGetVin.json";
import frNotifyDrivers from "../locales/fr/notifyDrivers.json";
import frUnknownVinDialog from "../locales/fr/unknownVinDialog.json";
import frYup from "../locales/fr/yup.json";

i18n.use(initReactI18next).init({
  lng: DEFAULT_LANGUAGE,
  ns: {
    namespaces: ["common"],
  },
  defaultNS: "common",
  resources: {
    en: {
      common: enCommon,
      home: enHome,
      fleetManagerInfo: enFleetManagerInfo,
      fleetVehicles: enFleetVehicles,
      commonLocationAddress: enCommonLocationAddress,
      stepIntro: enStepIntro,
      driverOnborading: enDriverOnboarding,
      notifyDrivers: enNotifyDrivers,
      fleetCongratulations: enFleetCongratulations,
      howToGetVin: enHowToGetVin,
      addVehicle: enAddVehicle,
      errorBoundary: enErrorBoundary,
      yup: enYup,
      accountCar: enAccountCar,
      completeVehicleDetails: enCompleteVehicleDetails,
      unknonwnVinDialog: enUnknownVinDialog,
    },
    fr: {
      common: frCommon,
      home: frHome,
      fleetManagerInfo: frFleetManagerInfo,
      fleetVehicles: frFleetVehicles,
      commonLocationAddress: frCommonLocationAddress,
      stepIntro: frStepIntro,
      stepIntro: frStepIntro,
      driverOnborading: frDriverOnboarding,
      notifyDrivers: frNotifyDrivers,
      fleetCongratulations: frFleetCongratulations,
      howToGetVin: frHowToGetVin,
      addVehicle: frAddVehicle,
      errorBoundary: frErrorBoundary,
      yup: frYup,
      accountCar: frAccountCar,
      completeVehicleDetails: frCompleteVehicleDetails,
      unknonwnVinDialog: frUnknownVinDialog,
    },
  },
  fallbackLng: "en",
});

export default i18n;
